import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    personalInfo: {
        fullname: "",
        phone: "",
        email: "",
        nationality: "",
        id_or_passport: ""
    },
    education: {
        level : "",
        field: "",
        other: ""
    },
    workExperience: {
        employer: "",
        experience: null,
    },
    postions: [],
    attachments: {
        cv:null,
        passport: null,
        degree: null,
        nid: null,
    },

    otherAttachments: [
       
    ],

    isPersonalInfoValid: false,
    isEducationValid: false,
    isWorkExperienceValid: false,
    isPostionsValid: false,
};


const applicationSlice = createSlice({
    name: "application",
    initialState,
    reducers:{
        setPersonalInfo: (state, action) => {
            state.personalInfo = action.payload;
            if (action.payload.fullname && action.payload.phone && action.payload.email) {
                state.isPersonalInfoValid=true
            }
        },
        setPersonalInfoValidation: (state, action) => {
            state.isPersonalInfoValid = Object.values(action.payload).every((value) => value);
        },
        setEducation: (state, action) => {
            state.education = action.payload;
        },
        setEducationValidation: (state, action) => {
            state.isEducationValid = Object.values(action.payload).every((value) => value);
        },
        setWorkExperience: (state, action) => {
            state.workExperience = action.payload;
        },
        setWorkExperienceValidation: (state, action) => {
            state.isWorkExperienceValid = Object.values(action.payload).every((value) => value);
        },
        setPostions: (state, action) => {
            state.postions = action.payload;
        },
        setPostionsValidation: (state, action) => {
            state.isPostionsValid = action.payload.length > 0;
        },
        setAttachments: (state, action) => {
            state.attachments = action.payload;
        },
        setOtherAttachments: (state, action) => {
            state.otherAttachments = action.payload;
        }
    }
}); 


export const { setPersonalInfo, setEducation, setWorkExperience, setPostions, setAttachments, setEducationValidation, setPersonalInfoValidation, setPostionsValidation, setWorkExperienceValidation, setOtherAttachments } = applicationSlice.actions;

export default applicationSlice.reducer;

